const Playlist = [
	{
		id: 1,
		name: "Travel",
	},
	{
		id: 2,
		name: "Dance",
	},
	{
		id: 3,
		name: "Relaxing",
	},
	{
		id: 4,
		name: "Working",
	},
	{
		id: 5,
		name: "HipHop",
	},
	{
		id: 6,
		name: "Workout",
	},
];

export { Playlist };
